import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const packageService = {
  getPackages: async (token) => {
    const res = await axios.get(`${API_URL}/api/admin/packages`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data.data;
  },
  createPackage: async (token, pkg) => {
    const res = await axios.post(`${API_URL}/api/admin/packages`, pkg, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data.data;
  },
  updatePackage: async (token, id, updates) => {
    const res = await axios.put(`${API_URL}/api/admin/packages/${id}`, updates, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data.data;
  },
  deletePackage: async (token, id) => {
    await axios.delete(`${API_URL}/api/admin/packages/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};

export default packageService; 